// extracted by mini-css-extract-plugin
export default {"goTop":"index_goTop_2aBxb"};